const administrativeUnits = {
  state: {
    administrativeUnits: [],
    administrativeUnit: {}
  },
  getters: {
    administrativeUnits(state) {
      return state.administrativeUnits;
    },
    administrativeUnit(state) {
      return state.administrativeUnit;
    }
  },
  mutations: {
    SET_ADMINISTRATIVE_UNITS_LIST(state, payload) {
      state.administrativeUnits = payload;
    },
    SET_ADMINISTRATIVE_UNIT(state, payload) {
      state.administrativeUnit = payload;
    }
  },
  actions: {
    async setAdministrativeUnit({ commit }, payload) {
      commit("SET_ADMINISTRATIVE_UNIT", payload);
    }
  }
};

export default administrativeUnits;



// WEBPACK FOOTER //
// ./src/vuex/setting/administrative_units.js